
import { getUserToken , getWxConfigType , getWxConfigId ,getScanUrl ,getServicerCode } from '@/store/cookie'


const getters = {
 
 
  user_detail: state => state.user.user_detail,
  company_main: state => {
    if(state.user.user_detail){
        if(state.user.user_detail.company && state.user.user_detail.company.length>0){
          let company = state.user.user_detail.company.find((item,index,arr)=>{
              if(item.relation_status == 1 && item.is_default == 1){
                  return item
              }
          })
          return company
        }else{
          return  null
        }
    }else{
      return  null
    }
  	
  },
  company_list: state => {
    if(state.user.user_detail){
    	if(state.user.user_detail.company){
    		return state.user.user_detail.company
    	}else{
    		return  []
    	}
    }else{
      return  []
    }
  },

  servicer_search_record : state => {
    if(state.user.servicer_search_record)
    {
      return state.user.servicer_search_record
    }else{
      return false
    }
  },

  user_notice_status:state =>{
    if(state.user.user_notice_status)
    {
      return state.user.user_notice_status
    }else{
      return 0
    }
  },

  create_order_cache:state => {
      if (state.user.create_order_cache) {
          return state.user.create_order_cache
      } else {
          return 0
      }
  },

  last_order_cache:state => {
      if(state.user.last_order_cache){
          if(state.user.last_order_cache.servicer_company_id > 0){
              return state.user.last_order_cache
          }else{
              return null
          }
      }else{
          return null
      }
  },

  trouble_describe_record: state => state.user.trouble_describe_record,


}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js